import { Server, Cloud, Shield, Zap, BarChart, Clock } from 'lucide-react';

export const mockData = {
  stats: [
    { value: '99.99%', label: 'Uptime Guarantee' },
    { value: '500+', label: 'Enterprise Clients' },
    { value: '24/7', label: 'Support Available' },
    { value: '15+', label: 'Years Experience' }
  ],

  about: {
    history: 'Nix Southeast Asia was established as a strategic subsidiary of Nix Global, bringing over 15 years of international data center expertise to the rapidly growing Southeast Asian market. Our journey began with a vision to provide world-class infrastructure solutions tailored to the unique needs of businesses in this dynamic region.',
    vision: 'To be the leading data center solutions provider in Southeast Asia, recognized for innovation, reliability, and exceptional service quality. We envision a future where businesses of all sizes have access to enterprise-grade infrastructure that drives their digital transformation.',
    mission: 'Our mission is to empower organizations with cutting-edge data center infrastructure, cloud solutions, and managed services that ensure optimal performance, security, and scalability. We are committed to delivering unparalleled reliability and support to help our clients achieve their business objectives.',
    achievements: [
      {
        title: 'Industry Leadership',
        description: 'Recognized as a top-tier data center provider with multiple industry certifications and awards for excellence in service delivery.'
      },
      {
        title: 'Global Network',
        description: 'Part of the Nix Global network with data centers across multiple continents, ensuring redundancy and optimal performance.'
      },
      {
        title: 'Client Success',
        description: 'Powered over 500 enterprise clients with 99.99% uptime, processing millions of transactions daily with zero data loss.'
      }
    ]
  },

  services: [
    {
      icon: Cloud,
      title: 'Cloud Hosting',
      description: 'Scalable cloud infrastructure with flexible resources, automatic scaling, and pay-as-you-go pricing. Perfect for growing businesses.'
    },
    {
      icon: Server,
      title: 'Server Management',
      description: 'Comprehensive server management including monitoring, maintenance, security updates, and performance optimization by expert teams.'
    },
    {
      icon: Shield,
      title: 'Colocation Services',
      description: 'Secure, climate-controlled facilities for your hardware with redundant power, cooling, and network connectivity.'
    },
    {
      icon: Zap,
      title: 'Disaster Recovery',
      description: 'Robust backup and disaster recovery solutions ensuring business continuity with rapid failover and data restoration capabilities.'
    },
    {
      icon: BarChart,
      title: 'Network Infrastructure',
      description: 'High-performance network solutions with redundant connectivity, DDoS protection, and optimized routing for minimal latency.'
    },
    {
      icon: Clock,
      title: 'Managed Services',
      description: '24/7 monitoring and management of your infrastructure with proactive maintenance, security, and support from certified experts.'
    }
  ],

  advantages: [
    {
      title: 'Carrier-Grade Infrastructure',
      description: 'State-of-the-art facilities with N+1 redundancy, multiple carrier connections, and enterprise-grade hardware ensuring maximum uptime and performance.'
    },
    {
      title: 'Strategic Locations',
      description: 'Data centers positioned in key Southeast Asian markets providing low latency access and compliance with local data sovereignty requirements.'
    },
    {
      title: 'Expert Support Team',
      description: 'Dedicated support engineers available 24/7/365 with deep technical expertise and rapid response times for any issue or question.'
    },
    {
      title: 'Security & Compliance',
      description: 'ISO 27001 certified facilities with biometric access, 24/7 surveillance, and compliance with international security standards.'
    },
    {
      title: 'Scalable Solutions',
      description: 'Flexible infrastructure that grows with your business, from startup to enterprise scale, with seamless migration and expansion options.'
    },
    {
      title: 'Cost Efficiency',
      description: 'Competitive pricing with transparent billing, no hidden fees, and flexible payment options that optimize your IT infrastructure costs.'
    }
  ],

  testimonials: [
    {
      name: 'Sarah Chen',
      position: 'CTO',
      company: 'TechVision Solutions',
      feedback: 'Migrating to Nix Southeast Asia was the best decision for our infrastructure. The uptime has been impeccable, and their support team is incredibly responsive and knowledgeable.'
    },
    {
      name: 'Michael Tan',
      position: 'IT Director',
      company: 'Global Finance Corp',
      feedback: 'The disaster recovery solutions provided by Nix gave us peace of mind. When we needed to test our failover systems, everything worked flawlessly. Truly enterprise-grade service.'
    },
    {
      name: 'Lisa Wong',
      position: 'CEO',
      company: 'E-Commerce Innovations',
      feedback: 'As our business grew rapidly, Nix Southeast Asia scaled seamlessly with us. Their cloud hosting solutions handle our peak traffic without any performance issues. Excellent partnership!'
    }
  ],

  contact: {
    email: 'info@nix-southeast-asia.com',
    phone: '+65 6789 1234',
    address: 'Marina Bay Financial Centre, Tower 3, Level 15, Singapore 018989',
    hours: {
      weekdays: 'Monday - Friday: 9:00 AM - 6:00 PM',
      weekend: 'Saturday - Sunday: Emergency Support Only'
    }
  }
};